module.exports = __webpack_public_path__ + "static/media/dany_specification.7668c26c.md";